import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["size"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// DO NOT EDIT IT MANUALLY

import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var SvgManagedPangolin = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 24 : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  props.width = undefined;
  props.height = undefined;
  var testId = 'icon-managed-pangolin';
  var style = {};
  var isCustomSize = typeof size === 'number';
  if (isCustomSize) {
    style.width = size + 'px';
    style.height = size + 'px';
    if (!props.style) props.style = {};
    props.style.width = size + 'px';
    props.style.height = size + 'px';
  }
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    "data-test-id": testId,
    ref: ref
  }, props), {}, {
    children: /*#__PURE__*/_jsx("path", {
      d: "M10.811 3.277a.9.9 0 0 0-.481.375c-.065.119-.071.403-.082 4.008-.008 2.726.001 3.925.032 4.031a1 1 0 0 0 .171.296c.367.418.992.313 1.233-.207.067-.145.074-.279.075-1.426l.001-1.266.89-.019c.996-.021 1.153-.049 1.69-.309.685-.333 1.121-.85 1.329-1.58.078-.274.112-1.283.057-1.693-.124-.92-.578-1.577-1.346-1.945-.509-.244-.73-.273-2.16-.287-.704-.006-1.338.004-1.409.022m2.663 1.525c.299.065.537.234.65.463.09.183.096.237.096.895 0 .762-.014.822-.246 1.057-.143.144-.455.29-.732.343-.117.022-.498.04-.847.04h-.635V4.76h.758c.417 0 .847.019.956.042M2.26 12.25c.038.341.191.791.392 1.149.219.389.878 1.059 1.368 1.389 1.456.981 3.531 1.624 6.06 1.878.965.096 2.875.096 3.84 0 2.977-.299 5.406-1.169 6.715-2.406.663-.627 1.01-1.264 1.106-2.035l.028-.225h-1.518l-.022.162c-.059.44-.505.992-1.149 1.42-1.153.768-2.874 1.304-5.02 1.564-.862.104-3.258.104-4.12 0-2.147-.26-3.874-.799-5.017-1.563-.648-.434-1.092-.972-1.148-1.39L3.75 12H2.232zm0 5c.038.341.191.791.392 1.149.219.389.878 1.059 1.368 1.389 1.456.981 3.531 1.624 6.06 1.878.965.096 2.875.096 3.84 0 2.977-.299 5.406-1.169 6.715-2.406.663-.627 1.01-1.264 1.106-2.035l.028-.225h-1.518l-.022.162c-.059.44-.505.992-1.149 1.42-1.153.768-2.874 1.304-5.02 1.564-.862.104-3.258.104-4.12 0-2.147-.26-3.874-.799-5.017-1.563-.648-.434-1.092-.972-1.148-1.39L3.75 17H2.232z"
    })
  }));
});
export default SvgManagedPangolin;